import { styled, Typography } from "@mui/material";

export const WrappedTypography = styled(Typography)({
  whiteSpace: "normal",
  wordBreak: "break-word",
});
